import { Box } from '@mui/material';

import { Constants } from '../../constants';
import { AvatarCircle, CardCount, CardName, CardWrapper } from './styles';

const AVATAR_COLORS = [
  '#009688',
  '#FF7043',
  '#7B1FA2',
  '#1565C0',
  '#AD1457',
  '#00838F',
];

const getInitials = (name: string): string => {
  const words = name.trim().split(/\s+/);
  if (words.length === 1) return words[0].slice(0, 2).toUpperCase();
  return (words[0][0] + words[1][0]).toUpperCase();
};

interface CompanyCardProps {
  id: number;
  name: string;
  pending: number;
  isSelected: boolean;
  onClick: () => void;
}

export function CompanyCard({
  id,
  name,
  pending,
  isSelected,
  onClick,
}: CompanyCardProps): JSX.Element {
  const color = AVATAR_COLORS[id % AVATAR_COLORS.length];

  return (
    <CardWrapper isSelected={isSelected} onClick={onClick}>
      <AvatarCircle sx={{ bgcolor: color }}>{getInitials(name)}</AvatarCircle>
      <Box>
        <CardName title={name}>{name}</CardName>
        <CardCount>
          {pending} {Constants.osPending}
        </CardCount>
      </Box>
    </CardWrapper>
  );
}
